import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CtbConfService, PageBusquedaObject, CtbConfEmp } from '../ctb-conf.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-conf.form',
  templateUrl: './catalogo-ctb-conf.component.html',
  styleUrls: ['./catalogo-ctb-conf.component.css'],
  preserveWhitespaces: true
})
export class CatalogoCtbConfComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: CtbConfEmp[];
  cargado: boolean;
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private router: Router, private ctaService: CtbConfService, public loginService: LoginService) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.filtroDeBusqueda(this.loginService.usuario.empresa_seleccionada.ctb_conf_emp_id, 'id');
  //this.busqueda.criteriaSearch['gral_usr_id'] = this.loginService.usuario.id as number;
    this.mostrarMensajeCarga();
    this.ctaService.catalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
      this.cerrarMensajeCarga();
    }, err => {
      this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.buscarEnCatalogo();
  }
  eliminar(dtoEliminar: CtbConfEmp): void {
    Swal.fire({
      title: 'TNK Ledger',
      text: `¿Está seguro de inhabilitar la empresa?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.ctaService.delete(dtoEliminar.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      showConfirmButton: false,
      timerProgressBar: true,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
